export default function Logo({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="PLC logo">
      <rect width="32" height="32" rx="4" fill="#0F0F0F" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#FFD700" strokeOpacity="0.4" />
      <path d="M8 5v22M24 5v22" stroke="#FFD700" strokeWidth="2.4" strokeLinecap="square" />
      <path d="M8 12h5M19 12h5" stroke="#FFFFFF" strokeWidth="2" />
      <path d="M13 9.5v5M19 9.5v5" stroke="#FFFFFF" strokeWidth="2" />
      <circle cx="16" cy="21" r="2.6" stroke="#FFD700" strokeWidth="2" />
      <path d="M8 21h5.4M18.6 21H24" stroke="#FFFFFF" strokeWidth="2" />
    </svg>
  );
}
